import apiClient from "../../../service/apiClient";
import { ASSET_ENDPOINTS } from "../../../app/apiEndpoints";

export const getInvestorsByContact = (contactId) =>
  apiClient.get(ASSET_ENDPOINTS.GET_INVESTORS_BY_CONTACT, {
    params: { contactId }
  });

export const getEntitiesByInvestor = (investorId, contactId) =>
  apiClient.get(ASSET_ENDPOINTS.GET_ENTITIES_BY_INVESTOR, {
    params: { investorId:investorId, contactId:contactId }
  });

export const getReportDates = (contactId) =>
  apiClient.get(ASSET_ENDPOINTS.GET_REPORT_DATES, {
    params: { contactId }
  });

export const getAssetSummaryAndAllocation = (
  reportingMonth,
  accountId,
  contactId
) =>
  apiClient.get(ASSET_ENDPOINTS.GET_ASSET_SUMMARY_AND_ALLOCATION, {
    params: {
      reportingMonth,
      accountId,
      contactId
    }
  });


  export const getReportDatesForAccountOrContact = (accountId, contactId) =>
  apiClient.get(ASSET_ENDPOINTS.GET_REPORT_DATES_FOR_ACCOUNT_OR_CONTACT, {
    params: { AccountId: accountId, ContactId: contactId }
  });
  
export const getAssetStrategyList = (reportingMonth, accountId, contactId) =>
  apiClient.get(ASSET_ENDPOINTS.GET_ASSET_STRATEGY_LIST, {
    params: { reportingMonth, accountId, contactId }
  });

export const getAssetPerformanceDetails = (
  reportingMonth,
  accountId,
  contactId,
  strategyId
) =>
  apiClient.get(ASSET_ENDPOINTS.GET_ASSET_PERFORMANCE_DETAILS, {
    params: { reportingMonth, accountId, contactId, strategyId }
  });
